export const GLOBAL_CONSTANTS: any = {
    textareaLength: 5000
};

export const FORM_STATUS: any = {
    LOADING: 'loading',
    LOADED: 'loaded',
    SAVED: 'saved',
    SUBMITTED: 'submitted',
    ERROR: 'error'
};

export const MODE: any = {
    EDIT: 'edit',
    AMEND: 'amend',
    READONLY: 'readOnly'
};

export const TOKEN_COOKIE = 'authtoken';




// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/constant/globals.ts